import React from 'react';

import HCPVault from '../../images/vault-enterprise.svg';

export const HCPVaultLogo = () => {
  return <img height="32" src={HCPVault} alt="HCP Vault logo" />;
};
